





























import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class IndicatorModal extends Vue {
  @Prop({ default: false })
  private display: boolean;

  @Prop({ default: false })
  private hide: boolean;

  @Prop({ default: '#999999' })
  private color: string;

  @Prop({ default: '#F0F0F0' })
  private backgroundColor: string;
}
